import React from 'react';
import PropTypes from 'prop-types';
import _ from 'lodash';
import AvatarGroup from '../elements-image/avatar-group';
import classnames from 'classnames';
import { FormattedMessage, injectIntl } from 'react-intl';

const AttendeeListCompact = ({
  attendees = {},
  pendingAttendees = [],
  className = '',
  showRsvpText = false,
  isLoggedIn = false,
  onClick = null,
  showViewGuestListLink = false,
  urlPrefix = '',
  redirectLocation = '',
  isGoing = false,
  hasUserRSVP = false,
  intl
}) => {
  const repliedAttendees = _.filter(attendees, 'rsvp');
  const attendeesSortedByAvatar = _.sortBy(attendees, (attendee) => _.get(attendee, 'avatar-id'));
  const attendeeAvatarUrls = _.compact(_.map(attendeesSortedByAvatar, (attendee) => _.get(attendee, 'avatar-url')));
  const attendeeAvatarUrlsToDisplay = _.take(attendeeAvatarUrls, 3);

  const logInMessage =
    <a className='underline text-gray-600' href={`${urlPrefix}/signin${redirectLocation}`} rel='nofollow'>
      <FormattedMessage
        id='invite.attendee_list_compact.login_link'
        defaultMessage='log in'
      />
    </a>;

  const rsvpDetailsLoggedOutMessage =
    <FormattedMessage
      id='invite.attendee_list_compact.rsvp_details_logged_out'
      defaultMessage='RSVP or {link} to see guest list'
      values={{
        link: logInMessage
      }}
    />;


  const rsvpDetailsMessage = <FormattedMessage
    id='invite.attendee_list_compact.rsvp_details'
    defaultMessage='RSVP to see guest list'
  />;

  const viewGuestListMessage = <FormattedMessage id='invite.attendee_list_compact.view_guests' defaultMessage='View Guest List' />;

  const rsvpText = (showRsvpText && isLoggedIn && !isGoing && !hasUserRSVP)
    ? rsvpDetailsMessage
    : (showRsvpText && isLoggedIn && (isGoing || hasUserRSVP))
      ? <FormattedMessage
        id='invite.attendee_list_compact.rspv_not_going'
        defaultMessage='{link}'
        values={{
          link: (
            <span className='underline'>
              {viewGuestListMessage}
            </span>
          )
        }}
      />
      : showRsvpText
      && rsvpDetailsLoggedOutMessage;

  const noAttendeeRSVPText = (isLoggedIn && !isGoing)
    ? rsvpDetailsMessage
    : (isLoggedIn && isGoing && showViewGuestListLink)
      ? viewGuestListMessage
      : !isLoggedIn
      && rsvpDetailsLoggedOutMessage;

  const attendeePeopleTense = 1 === repliedAttendees.length
    ? intl.formatMessage({ id: 'invite.attendee_list_compact.attendee_person', defaultMessage: 'person' })
    : intl.formatMessage({ id: 'invite.attendee_list_compact.attendee_people', defaultMessage: 'people' });
  const pendingPeopleTense = 1 === pendingAttendees.length
    ? intl.formatMessage({ id: 'invite.attendee_list_compact.pending_person', defaultMessage: 'person' })
    : intl.formatMessage({ id: 'invite.attendee_list_compact.pending_people', defaultMessage: 'people' });
  const isAttendeesEmpty = _.isEmpty(attendees);
  const isPendingAttendeesEmpty = _.isEmpty(pendingAttendees);
  const defaultImage = '/web-2/assets/images/no_avatar_placeholder.svg?v=rb';
  const pendingAvatarUrls = [defaultImage, defaultImage, defaultImage];
  const pendingAvatarUrlsToDisplay = _.take(pendingAvatarUrls, pendingAttendees.length);

  return (
    <div className={classnames('AttendeeListCompact flex flex-wrap', className)} onClick={onClick}>
      { !isAttendeesEmpty &&
        <span className="flex middle" data-testing-id="attendee-container">
          <AvatarGroup urls={attendeeAvatarUrlsToDisplay} className={"flex margin-md-right"} />

          <span className="text-small text-gray-600">
            <FormattedMessage
              id='invite.attendee_list_compact.replied'
              defaultMessage='{length} {attendeePeople} replied already - {rsvp}'
              values={{
                length: repliedAttendees.length,
                attendeePeople: attendeePeopleTense,
                rsvp: rsvpText
              }}
            />
          </span>
        </span>
      }

      { !isPendingAttendeesEmpty && isAttendeesEmpty &&
        <span className="flex flex-no-wrap margin-md-bottom" data-testing-id="pending-attendee-container">
          <AvatarGroup urls={pendingAvatarUrlsToDisplay} />

          <FormattedMessage
            id='invite.attendee_list_compact.invited'
            defaultMessage='{length} {pendingPeople} have been invited - {rsvp}'
            values={{
              length: pendingAttendees.length,
              pendingPeople: pendingPeopleTense,
              rsvp: rsvpText
            }}
          />
        </span>
      }

      {isPendingAttendeesEmpty && isAttendeesEmpty &&
       <span className="text-small text-gray-600">
          {noAttendeeRSVPText}
       </span>
      }

      {showViewGuestListLink &&
        <button className='btn-link' data-testing-id="view-guest-link">
          { viewGuestListMessage }
        </button>
      }
    </div>
  );
};

AttendeeListCompact.propTypes = {
  attendees: PropTypes.object,
  pendingAttendees: PropTypes.object,
  className: PropTypes.string,
  showRsvpText: PropTypes.bool,
  isLoggedIn: PropTypes.bool,
  redirectLocation: PropTypes.string,
  showViewGuestListLink: PropTypes.bool,
  onClick: PropTypes.func
};

export default injectIntl(AttendeeListCompact);
